import { Link } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const recentArticles = getRecentArticles(6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">赛事资讯</span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            最新赛事动态
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            掌握第一手赛事资讯、攻略技巧和行业动态，让你在竞技中始终快人一步。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {recentArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden hover:bg-background-100 transition-all cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 bg-primary-500 text-background-50 rounded-md text-xs font-medium whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/zonghe-saishi"
            className="inline-flex items-center gap-2 px-6 py-3 border border-secondary-300 text-foreground-700 rounded-lg text-sm font-medium hover:bg-secondary-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}